<!-- Use [hidden] instead of *ngIf because the grid will loose its state (sorting, grouping, etc.) when using *ngIf -->
<div [hidden]="currentTransportConfiguration">
    <dx-data-grid biz-grid [selection]='{ mode: "single" }' [showIsLoading]="isLoading" [dataSource]='transportConfigurations'
        (bizOnToolbarPreparing)="onToolbarPreparing($event)" (rowDoubleClick)="editTransportConfiguration($event)">
        <dxo-editing mode="row" [allowUpdating]="false" [allowAdding]="false" [allowDeleting]="false"></dxo-editing>

        @if (this.someBlockedByImport) {
            <dxi-column dataField="BlockedByImport" caption="Blocked" dataType="boolean" allowFiltering="true"></dxi-column>
        }

        <dxi-column dataField="Name" caption="Name" dataType="string" sortOrder="asc"></dxi-column>
        <dxi-column caption="Transport Type" [calculateDisplayValue]="getTransportTypeName" dataType="string"></dxi-column>
        <dxi-column dataField="DisplayAddress" caption="Display Address" dataType="string"></dxi-column>
        <dxi-column dataField="PartnerSystemId" caption="Partner System" dataType="string">
            <dxo-lookup [dataSource]="partnerSystems" valueExpr="Id" displayExpr="Name"></dxo-lookup>
        </dxi-column>
        <dxi-column dataField="MonitorItem.currentStatus.EffectiveStatus" caption="Monitor status" cellTemplate="statusTemplate" alignment="center">
            <div *dxTemplate="let data of 'statusTemplate'">
                <app-status-traffic-light [status]="data.value"></app-status-traffic-light>
            </div>
        </dxi-column>
        <dxi-column caption="" cellTemplate="transportConfigurationsViewTemplate" [width]="someBlockedByImport ? 185 : 130"></dxi-column>
        <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false">
            <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(transportConfigurations, 'CreatedBy'))"></dxo-header-filter>
        </dxi-column>
        <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
        <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false">
            <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(transportConfigurations, 'UpdatedBy'))"></dxo-header-filter>
        </dxi-column>
        <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="false" format="dateTime"></dxi-column>

        <div *dxTemplate="let cell of 'transportConfigurationsViewTemplate'">
            <ng-container *bizPermissionRequired="'Partner_Action_InternalPartner'; evaluator:evaluatePermissions; trigger: selectedPartner">
                @if(cell.data.BlockedByImport){
                    <a class="dx-link" (click)="unblockLocation(cell.data)">unblock</a>&nbsp;
                }
                @if(cell.data.canEdit){
                    <a class="dx-link" (click)="editTransportConfiguration(cell.data)">Edit</a>&nbsp;
                }
                @if(cell.data.canClone){
                    <a class="dx-link" (click)="cloneTransportConfiguration(cell.data)">Copy</a>&nbsp;    
                }
                @if(cell.data.canDelete){
                    <a class="dx-link" (click)="deleteTransportConfiguration(cell.data)">Delete</a>   
                }
            </ng-container>
        </div>
    </dx-data-grid>
</div>

<ep-transport-configuration-edit [hidden]="!currentTransportConfiguration" [transportConfiguration]="currentTransportConfiguration" [partnerRestrictedMode]="true"
    (cancelled)="cancel()" (saved)="saved()">
</ep-transport-configuration-edit>
